import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType } from './getExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType;
};
